import React from "react";
import styles from "./Owner.module.scss";
import Image from "next/image";

const Owner = () => {
  return (
    <section className={styles.owner}>
      <div className={styles.container}>
        <div className={styles.image}>
          <Image
            src='/assets/Image/coins.png'
            width={405}
            height={460}
            quality={100}
            alt='coins'
          />
        </div>
        <div className={styles.contant}>
          <h1 className={styles.title}>
            Powered By
            <br />
            <span className={styles.spanTitle}>B-LOVE Token</span>
          </h1>
          <p className={styles.paragraph}>
            B-Love Token (BLV) is a community-reward token deployed on the BFIC
            Blockchain. The BLV token has a maximum supply of 20 billion tokens,
            and will follow a progressive supply burn mechanism to elevate the
            internal value.
          </p>
        </div>
      </div>
    </section>
  )
};

export default Owner;
